export default {
  "mainVegetable": "legumes",
  "mainVegetable/01": "legumes/aubergines",
  "mainVegetable/02": "legumes/asperges",
  "mainVegetable/03": "legumes/avocats",
  "mainVegetable/04": "legumes/betteraves",
  "mainVegetable/05": "legumes/brocolis",
  "mainVegetable/06": "legumes/carottes",
  "mainVegetable/07": "legumes/celeri",
  "mainVegetable/08": "legumes/champignons",
  "mainVegetable/09": "legumes/chou",
  "mainVegetable/10": "legumes/chou-de-bruxelles",
  "mainVegetable/11": "legumes/chou-chinois",
  "mainVegetable/12": "legumes/chou-fleur",
  "mainVegetable/13": "legumes/coleslaw",
  "mainVegetable/14": "legumes/concombre",
  "mainVegetable/15": "legumes/courgettes",
  "mainVegetable/16": "legumes/endives",
  "mainVegetable/17": "legumes/epinards",
  "mainVegetable/18": "legumes/feves",
  "mainVegetable/19": "legumes/flageolets",
  "mainVegetable/20": "legumes/haricots-plats",
  "mainVegetable/21": "legumes/haricots-secs",
  "mainVegetable/22": "legumes/haricots-verts",
  "mainVegetable/23": "legumes/lentilles",
  "mainVegetable/24": "legumes/macedoine-de-legumes",
  "mainVegetable/25": "legumes/mais",
  "mainVegetable/26": "legumes/mesclun",
  "mainVegetable/27": "legumes/navets",
  "mainVegetable/28": "legumes/oignons",
  "mainVegetable/29": "legumes/petits-pois-soja",
  "mainVegetable/30": "legumes/poivrons",
  "mainVegetable/31": "legumes/pommes-de-terre",
  "mainVegetable/32": "legumes/pousses-de-soja",
  "mainVegetable/33": "legumes/radis",
  "mainVegetable/34": "legumes/salade-feuille-de-chene",
  "mainVegetable/35": "legumes/salade-frisee",
  "mainVegetable/36": "legumes/salade-iceberg",
  "mainVegetable/37": "legumes/salade-piemontaise",
  "mainVegetable/38": "legumes/salades-de-riz",
  "mainVegetable/39": "legumes/salade-romaine",
  "mainVegetable/40": "legumes/jeunes-pousses",
  "mainVegetable/41": "legumes/laitue",
  "mainVegetable/42": "legumes/mache",
  "mainVegetable/43": "legumes/roquette",
  "mainVegetable/44": "legumes/salsifis",
  "mainVegetable/45": "legumes/taboule",
  "mainVegetable/46": "legumes/tomates",
  "mainVegetable/47": "legumes/haricot-beurre",
  "mainVegetable/48": "legumes/pois-chiche",
  "mainVegetable/49": "legumes/poireaux",
  "mainVegetable/50": "legumes/potiron",
  "mainVegetable/51": "legumes/haricot-rouge",
  "mainVegetable/52": "legumes/pommes",
  "mainVegetable/53": "legumes/marrons",
  "mainVegetable/54": "legumes/pruneaux",
  "mainVegetable/55": "legumes/jardiniere",
  "mainVegetable/56": "legumes/olives-noires",
  "mainVegetable/57": "legumes/artichauts",
  "mainVegetable/58": "legumes/poivrons-rouges",
  "mainVegetable/59": "legumes/haricots-verts-plats",
  "mainVegetable/60": "legumes/printaniere",
  "mainVegetable/61": "legumes/ratatouille",
  "mainVegetable/62": "legumes/couscous",
  "mainVegetable/63": "legumes/tajine",
  "mainVegetable/64": "legumes/legumes-au-curry",
  "mainVegetable/65": "legumes/pois-casses",
  "mainVegetable/66": "legumes",
  "mainVegetable/67": "legumes/lentilles-corail",
  "mainVegetable/68": "legumes/quinoa",
  "mainVegetable/69": "legumes/epeautre",
  "mainVegetable/70": "legumes/boulgour",
  "mainVegetable/71": "legumes/chou-rouge",
  "mainVegetable/72": "legumes/kale",
  "mainVegetable/73": "legumes/cerfeuil",
  "mainVegetable/74": "legumes/grains-et-graines",
  "mainVegetable/75": "legumes/legumineuses",
  "mainVegetable/76": "legumes/patate-douce",
  "mainVegetable/77": "legumes/citrouille",
  "mainVegetable/78": "legumes/oseille",
  "mainVegetable/79": "legumes/haricots",
  "mainVegetable/80": "legumes/petits-pois-carrottes",
  "mainVegetable/81": "legumes/pois",
  "mainVegetable/82": "legumes/edamame",
  "mainVegetable/83": "legumes/orge",
  "mainVegetable/84": "legumes/melange-a-salade",
  "mainVegetable/85": "legumes/pain-de-sucre",
  "mainVegetable/86": "legumes/laitue-romaine",
  "mainVegetable/87": "legumes/epinards-mini",
  "mainVegetable/88": "legumes/lollo-verde",
  "mainVegetable/89": "legumes/bette-a-carde",
  "mainVegetable/90": "legumes/panais",
  "mainVegetable/91": "legumes/riz-noir",
  "mainVegetable/92": "legumes/melange-de-haricots",
  "mainVegetable/93": "legumes/haricots-noirs",
  "mainVegetable/94": "legumes/chou-pointu",
  "mainVegetable/95": "legumes/haricots-blancs",
  "mainVegetable/96": "legumes/tomates-sechee",
  "mainVegetable/97": "legumes/melange-de-legumes",
  "mainVegetable/98": "legumes/butternut",
  "productRange": "gammes",
  "productRange/4G_BIO": "gammes/4g-bio",
  "productRange/4G_SRP": "gammes/4g-srp",
  "productRange/BEAN_SAUCE": "gammes/haricots-en-sauce",
  "productRange/BEANS": "gammes",
  "productRange/BIO": "gammes/bio",
  "productRange/BON_SENGAG": "gammes/bonduelle-s-engage",
  "productRange/BOND_KIDS": "gammes",
  "productRange/CAN_A_POEL": "gammes/a-poeler-conserve",
  "productRange/CAN_BIO": "gammes",
  "productRange/CAN_BOCAL": "gammes",
  "productRange/CAN_PETITS": "gammes",
  "productRange/CAN_SEC_BI": "gammes/legumes-secs-cuits-dans-tres-peu-de-jus-bio-conser",
  "productRange/CAN_SEC_CO": "gammes/legumes-secs-cuisines-conserve",
  "productRange/CAN_SEC_CU": "gammes/legumes-secs-cuits-dans-tres-peu-de",
  "productRange/CAN_SEC_NA": "gammes/legumes-sec-nature-conserve",
  "productRange/CAN_SEC_PR": "gammes",
  "productRange/CAN_VAPEUR": "gammes/legumes-vapeur-conserve",
  "productRange/CAN_VEG_SA": "gammes/legumes-nature-saa-conserve",
  "productRange/CAN_VEG_SR": "gammes/legumes-nature-srp-conserve",
  "productRange/CARTA_DELL": "gammes",
  "productRange/CEREAL_CAN": "gammes",
  "productRange/CEREAL_FRZ": "gammes",
  "productRange/CEREALI": "gammes",
  "productRange/CEREALLEGR": "gammes",
  "productRange/CLASSICVEG": "gammes/legumes-classiques",
  "productRange/COCCOLE": "gammes",
  "productRange/COLDVEGE": "gammes/legumes-froids",
  "productRange/COO_VEG": "gammes/legumes-cuisines\t",
  "productRange/COOKMUSH": "gammes/champignons-de-paris-cuisines",
  "productRange/CORN": "gammes",
  "productRange/CREATIF": "gammes/creatif",
  "productRange/CROUSTIS": "gammes/croustis",
  "productRange/CRUDITES": "gammes/crudites",
  "productRange/DE_NOS_PRO": "gammes/de-nos-producteurs",
  "productRange/DOYMUSHACC": "gammes/champignons-cuisines-accompagnement",
  "productRange/DOYMUSHAPE": "gammes/champignons-cuisines-apero",
  "productRange/DRYVEGE": "gammes/legumes-secs",
  "productRange/FRANCAIS": "gammes/100-francais",
  "productRange/FROZENVEGE": "gammes/legumes-surgeles-a-partager",
  "productRange/FRZ_ASTUCE": "gammes/mes-astuces-legumes",
  "productRange/FRZ_FRY_MI": "gammes",
  "productRange/FRZ_GRATIN": "gammes/gratins",
  "productRange/FRZ_JUSTEA": "gammes/palet-de-legume",
  "productRange/FRZ_KELLO": "gammes/legumes-secs-et-cereales-surgeles",
  "productRange/FRZ_LEG_CO": "gammes/legumes-conventionnels-surgeles",
  "productRange/FRZ_MELANG": "gammes",
  "productRange/FRZ_POELEE": "gammes",
  "productRange/FRZ_PUREES": "gammes/purees-surgelee",
  "productRange/FRZ_VEG_BI": "gammes/bio-surgeles",
  "productRange/FRZ_VEG_SR": "gammes/srp-surgeles",
  "productRange/INDFROZVEG": "gammes/legumes-surgeles-individuels",
  "productRange/INSALATE_D": "gammes",
  "productRange/INSALATONA": "gammes/insalatona-piu",
  "productRange/JEUNES_POU": "gammes/jeunes-pousses",
  "productRange/LAITUES": "gammes/laitues",
  "productRange/LE_REGIONA": "gammes",
  "productRange/LEGUMIO": "gammes/legumio",
  "productRange/LOOP": "gammes/loop",
  "productRange/LUNCH_BOWL": "gammes/lunch-bowl",
  "productRange/MACHE_BASE": "gammes/mache-et-base-mache",
  "productRange/MEL_LAITUE": "gammes/melange-de-laitues",
  "productRange/MIXES_CORN": "gammes",
  "productRange/MONO_VEGE": "gammes",
  "productRange/MUSHNATEMI": "gammes/champignons-nature-eminces-conserve",
  "productRange/MUSHNATENT": "gammes/champignons-nature-entiers-conserve",
  "productRange/MUSHNATEPA": "gammes/champignons-nature-eminces-epais-co",
  "productRange/MUSHNATMIN": "gammes/champignons-nature-mini-conserve",
  "productRange/MUSHROOMS": "gammes/champignons",
  "productRange/NAT_MIX": "gammes/melanges-nature--------",
  "productRange/NATURA_IN": "gammes",
  "productRange/OTHER_VEG": "gammes",
  "productRange/PEAS": "gammes",
  "productRange/PREPARED_VEG": "gammes/legumes-prepares",
  "productRange/RAWOCOOK": "gammes/cru-ou-cuit",
  "productRange/READY_FROZ": "gammes/plats-cuisines-surgeles",
  "productRange/SALABIS": "gammes/salade",
  "productRange/SOUPS": "gammes/mes-astuces-legumes-pour-soupes",
  "productRange/SPINACH": "gammes",
  "productRange/STEAM_CAN": "gammes/vapeur",
  "productRange/STEAM_FRZ": "gammes",
  "productRange/STEAM_MIX": "gammes/melanges-surgeles-a-la-vapeur",
  "productRange/STUZZICHIA": "gammes",
  "productRange/SUNVEGE": "gammes/legumes-du-soleil",
  "productRange/TOUCHE": "gammes/touche-de",
  "productRange/TRAIT_CRUD": "gammes/traiteur-crudites",
  "productRange/TRAIT_SAL": "gammes",
  "productRange/TRAIT_TABO": "gammes/traiteur-taboules",
  "productRange/TUS_RECETA": "gammes/tes-recettes",
  "productRange/VEG_TO_FRY": "gammes",
  "productRange/VEGGIE": "gammes/veggie-rice",
  "productRange/WORLDVEGE": "gammes/legumes-du-monde",
  "season": "saisons",
  "season/1": "saisons/ete",
  "season/2": "saisons/automne",
  "season/3": "saisons/hiver",
  "season/4": "saisons/printemps",
  "season/5": "saisons/noel",
  "technologie": "techno",
  "technologie/AC01": "techno/conserve",
  "technologie/AD01": "techno/surgele",
  "technologie/AG01": "techno/frais",
  "technologie/AT01": "techno/traiteur",
  "recipeDish": "type",
  "recipeDish/ACC": "type/accompagnement",
  "recipeDish/APE": "type/aperitif",
  "recipeDish/DES": "type/dessert",
  "recipeDish/ENT": "type/entree",
  "recipeDish/PLAT": "type/plat",
  "recipeDish/SAL": "type/salade",
  "recipeDish/SNA": "type/snack",
  "recipeDish/PDE": "type/petit-dejeuner",
  "recipeDish/DEJ": "type/dejeuner",
  "recipeDish/TRA": "type/traditionnel",
  "recipeDish/GOU": "type/gourmet",
  "recipeDish/ETH": "type/ethnique",
  "recipeDish/FCH": "type/pour-les-enfants",
  "recipeDish/SOU": "type/soupe",
  "pred-recipeTimingCook-facet": "cuisson",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "cuisson/0-15-minutes",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "cuisson/15-30-minutes",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "cuisson/30-45-minutes",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "cuisson/45-minutes",
  "pred-recipeTimingPreparation-facet": "preparation",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "preparation/0-15-minutes",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "preparation/15-30-minutes",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "preparation/30-45-minutes",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "preparation/45-minutes",
  "pred-recipeCost-Facet": "budget",
  "pred-recipeCost-Facet/petit": "budget/petit",
  "pred-recipeCost-Facet/moyen": "budget/moyen",
  "pred-recipeCost-Facet/grand": "budget/grand",
  "recipeDifficulty": "preparation",
  "recipeDifficulty/1": "preparation/facile",
  "recipeDifficulty/2": "preparation/moyen",
  "recipeDifficulty/3": "preparation/difficile",
  "recipeDishNumber": "convives",
  "recipeDishNumber/1": "convives/1",
  "recipeDishNumber/2": "convives/2",
  "recipeDishNumber/3": "convives/3",
  "recipeDishNumber/4": "convives/4",
  "recipeDishNumber/5": "convives/5",
  "recipeDishNumber/6": "convives/6",
  "recipeDishNumber/7": "convives/7",
  "recipeDishNumber/8": "convives/8",
  "productTheme": "produits-par-theme",
  "productTheme/ACC": "produits-par-theme/accompagnement",
  "productTheme/BEA": "produits-par-theme/haricots",
  "productTheme/BIS": "produits-par-theme/haricots-en-sauce",
  "productTheme/BIO": "produits-par-theme/bio",
  "productTheme/CAN": "produits-par-theme/conserves",
  "productTheme/CER": "produits-par-theme/cereales",
  "productTheme/CLS": "produits-par-theme/classiques",
  "productTheme/DLE": "produits-par-theme/legumes",
  "productTheme/EDR": "produits-par-theme/enrichisseurs-de-repas",
  "productTheme/ENT": "produits-par-theme/entrees",
  "productTheme/FRZ": "produits-par-theme/surgele",
  "productTheme/FSD": "produits-par-theme/pour-les-salades",
  "productTheme/FSH": "produits-par-theme/frais",
  "productTheme/ING": "produits-par-theme/ingredients-pour-mes-recettes",
  "productTheme/JAR": "produits-par-theme/legumes-en-bocaux",
  "productTheme/LBW": "produits-par-theme/lunch-bowl",
  "productTheme/LDF": "produits-par-theme/legumes-au-four",
  "productTheme/LEG": "produits-par-theme/les-legumineuses",
  "productTheme/LGO": "produits-par-theme/legumio",
  "productTheme/LGR": "produits-par-theme/legumes-grilles",
  "productTheme/LGS": "produits-par-theme/legumes-pour-soupes",
  "productTheme/MAI": "produits-par-theme/le-mais",
  "productTheme/MUS": "produits-par-theme/champignons",
  "productTheme/NEW": "produits-par-theme/nouveaux-produits",
  "productTheme/PDH": "produits-par-theme/plats-cuisines-de-legumes-secs",
  "productTheme/PDL": "produits-par-theme/panier-de-legumes",
  "productTheme/PHR": "produits-par-theme/pates-et-riz-de-legumineuses",
  "productTheme/PLP": "produits-par-theme/plat-principal",
  "productTheme/RAL": "produits-par-theme/riz-aux-legumes",
  "productTheme/RDM": "produits-par-theme/plats-cuisines",
  "productTheme/SAL": "produits-par-theme/tout-pour-mes-salades",
  "productTheme/SDB": "produits-par-theme/salades-bowls",
  "productTheme/SNK": "produits-par-theme/snacking",
  "productTheme/SUP": "produits-par-theme/soupe",
  "productTheme/TEX": "produits-par-theme/tex-mex",
  "productTheme/VGP": "produits-par-theme/proteines-vegetales",
  "recipeTheme": "recettes-par-theme",
  "recipeTheme/01": "recettes-par-theme/recettes-festives",
  "recipeTheme/02": "recettes-par-theme/aperitif",
  "recipeTheme/03": "recettes-par-theme/salades-et-snacks",
  "recipeTheme/04": "recettes-par-theme/soupes-et-gaspachos",
  "recipeTheme/05": "recettes-par-theme/quiches-tartes-et-gratins",
  "recipeTheme/06": "recettes-par-theme/special-enfants",
  "recipeTheme/07": "recettes-par-theme/desserts",
  "recipeTheme/08": "recettes-par-theme/vegetariennes",
  "recipeTheme/09": "recettes-par-theme/accompagnements",
  "recipeTheme/10": "recettes-par-theme/venues-d-ailleurs",
  "recipeTheme/11": "recettes-par-theme/mijotes",
  "recipeTheme/12": "recettes-par-theme/salades-et-barbecues",
  "recipeTheme/13": "recettes-par-theme/snacks-et-fingerfood",
  "recipeTheme/14": "recettes-par-theme/plat-principal",
  "recipeTheme/15": "recettes-par-theme/desserts-et-patisseries",
  "recipeTheme/16": "recettes-par-theme/entrees-et-soupes",
  "recipeTheme/17": "recettes-par-theme/salades",
  "recipeTheme/18": "recettes-par-theme/bols",
  "recipeTheme/19": "recettes-par-theme/soupes",
  "recipeTheme/20": "recettes-par-theme/collations",
  "recipeTheme/21": "recettes-par-theme/sauce",
  "recipeTheme/22": "recettes-par-theme/plats-uniques",
  "recipeTheme/23": "recettes-par-theme/autres-plats",
  "recipeTheme/24": "recettes-par-theme/plats-au-four",
  "recipeTheme/25": "recettes-par-theme/mexicain",
  "recipeTheme/26": "recettes-par-theme/le-tour-du-monde",
  "recipeTheme/27": "recettes-par-theme/une-journee-sans-viande",
  "recipeTheme/28": "recettes-par-theme/faible-en-glucides",
  "recipeTheme/33": "recettes-par-theme/base-de-lentilles",
  "recipeTheme/34": "recettes-par-theme/base-de-chou-fleur",
  "recipeTheme/35": "recettes-par-theme/base-de-pommes-de-terre",
  "recipeTheme/36": "recettes-par-theme/base-de-carottes",
  "recipeTheme/37": "recettes-par-theme/base-d-epinards",
  "recipeTheme/38": "recettes-par-theme/base-de-poivrons",
  "recipeTheme/39": "recettes-par-theme/base-de-champignons",
  "recipeTheme/40": "recettes-par-theme/base-de-haricots-verts-plats",
  "recipeTheme/41": "recettes-par-theme/base-de-mais",
  "recipeTheme/42": "recettes-par-theme/base-petits-pois",
  "recipeTheme/43": "recettes-par-theme/base-haricots-rouges",
  "recipeTheme/44": "recettes-par-theme/base-flageolets",
  "recipeTheme/45": "recettes-par-theme/base-pois-chiche",
  "recipeTheme/46": "recettes-par-theme/base-broccolis",
  "pred-particularite": "habitudes-alimentaires",
  "pred-particularite/Sans%20conservateur": "habitudes-alimentaires/sans-conservateur",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "habitudes-alimentaires/sel-naturellement-present",
  "pred-particularite/Sans%20colorant": "habitudes-alimentaires/sans-colorant",
  "pred-particularite/Sans%20sucre%20ajout%E9": "habitudes-alimentaires/sans-sucres-ajoute",
  "pred-particularite/Sans%20sel%20ajout%E9": "habitudes-alimentaires/sans-sel-ajoute",
  "pred-particularite/Sans%20additif": "habitudes-alimentaires/sans-additif",
  "pred-particularite/": "habitudes-alimentaires/sel-naturellement-present",
  "pred-particularite/Sans%20lactose": "habitudes-alimentaires/sans-lactose",
  "pred-particularite/Sans%20gluten": "habitudes-alimentaires/sans-gluten",
  "pred-particularite/V%E9g%E9tarien": "habitudes-alimentaires/vegetarien",
  "pred-particularite/V%E9g%E9talien": "habitudes-alimentaires/vegetalien",
  "pred-particularite/Sans%20sulfite": "habitudes-alimentaires/sans-sulfite",
  "pred-particularite/A%20la%20vapeur": "habitudes-alimentaires/vapeur",
  "pred-particularite/Sans%20condiment": "habitudes-alimentaires/sans-condiment",
  "cultureType": "type-de-culture",
  "cultureType/Bio": "type-de-culture/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "type-de-culture/sans-residu-de-pesticide",
  "cultureType/Sans%20OGM": "type-de-culture/sans-ogm",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "habitudes-alimentaires/vegetalien",
  "pred-particularite/recipeVeggie": "habitudes-alimentaires/vegetarien",
  "pred-particularite/recipeGlutenfree": "habitudes-alimentaires/sans-gluten",
  "pred-particularite/recipeLactosefree": "habitudes-alimentaires/sans-lactose",
  "cultureOrigin": "origine-de-culture",
  "cultureOrigin/31": "origine-de-culture/azerbaidjan",
  "cultureOrigin/32": "origine-de-culture/argentine",
  "cultureOrigin/36": "origine-de-culture/australie",
  "cultureOrigin/40": "origine-de-culture/autriche",
  "cultureOrigin/51": "origine-de-culture/armenie",
  "cultureOrigin/56": "origine-de-culture/belgique",
  "cultureOrigin/68": "origine-de-culture/bolivie",
  "cultureOrigin/70": "origine-de-culture/bosnie-herzegovine",
  "cultureOrigin/76": "origine-de-culture/bresil",
  "cultureOrigin/97": "origine-de-culture/union-europeenne",
  "cultureOrigin/100": "origine-de-culture/bulgarie",
  "cultureOrigin/104": "origine-de-culture/birmanie",
  "cultureOrigin/120": "origine-de-culture/cameroun",
  "cultureOrigin/124": "origine-de-culture/canada",
  "cultureOrigin/152": "origine-de-culture/chili",
  "cultureOrigin/156": "origine-de-culture/chine",
  "cultureOrigin/188": "origine-de-culture/costa-rica",
  "cultureOrigin/191": "origine-de-culture/croatie",
  "cultureOrigin/196": "origine-de-culture/chypre",
  "cultureOrigin/203": "origine-de-culture/republique-tcheque",
  "cultureOrigin/208": "origine-de-culture/danemark",
  "cultureOrigin/231": "origine-de-culture/ethiopie",
  "cultureOrigin/233": "origine-de-culture/estonie",
  "cultureOrigin/246": "origine-de-culture/finlande",
  "cultureOrigin/250": "origine-de-culture/france",
  "cultureOrigin/258": "origine-de-culture/polynesie-francaise",
  "cultureOrigin/276": "origine-de-culture/allemagne",
  "cultureOrigin/300": "origine-de-culture/grece",
  "cultureOrigin/320": "origine-de-culture/guatemala",
  "cultureOrigin/344": "origine-de-culture/hong-kong",
  "cultureOrigin/348": "origine-de-culture/hongrie",
  "cultureOrigin/352": "origine-de-culture/islande",
  "cultureOrigin/356": "origine-de-culture/indes",
  "cultureOrigin/360": "origine-de-culture/indonesie",
  "cultureOrigin/372": "origine-de-culture/irlande",
  "cultureOrigin/376": "origine-de-culture/israel",
  "cultureOrigin/380": "origine-de-culture/italie",
  "cultureOrigin/398": "origine-de-culture/kazakhstan",
  "cultureOrigin/404": "origine-de-culture/kenya",
  "cultureOrigin/414": "origine-de-culture/koweit",
  "cultureOrigin/417": "origine-de-culture/kyrgyzstan",
  "cultureOrigin/422": "origine-de-culture/liban",
  "cultureOrigin/428": "origine-de-culture/lettonie",
  "cultureOrigin/440": "origine-de-culture/lituanie",
  "cultureOrigin/442": "origine-de-culture/luxembourg",
  "cultureOrigin/450": "origine-de-culture/madagascar",
  "cultureOrigin/470": "origine-de-culture/malte",
  "cultureOrigin/480": "origine-de-culture/ile-maurice",
  "cultureOrigin/484": "origine-de-culture/mexique",
  "cultureOrigin/498": "origine-de-culture/moldavie",
  "cultureOrigin/499": "origine-de-culture/montenegro",
  "cultureOrigin/504": "origine-de-culture/maroc",
  "cultureOrigin/528": "origine-de-culture/pays-bas",
  "cultureOrigin/548": "origine-de-culture/vanuatu",
  "cultureOrigin/578": "origine-de-culture/norvege",
  "cultureOrigin/586": "origine-de-culture/pakistan",
  "cultureOrigin/604": "origine-de-culture/perou",
  "cultureOrigin/616": "origine-de-culture/pologne",
  "cultureOrigin/620": "origine-de-culture/portugal",
  "cultureOrigin/634": "origine-de-culture/qatar",
  "cultureOrigin/642": "origine-de-culture/roumanie",
  "cultureOrigin/643": "origine-de-culture/russie",
  "cultureOrigin/703": "origine-de-culture/slovaquie",
  "cultureOrigin/704": "origine-de-culture/vietnam",
  "cultureOrigin/705": "origine-de-culture/slovenie",
  "cultureOrigin/724": "origine-de-culture/espagne",
  "cultureOrigin/752": "origine-de-culture/suede",
  "cultureOrigin/756": "origine-de-culture/suisse",
  "cultureOrigin/764": "origine-de-culture/thailande",
  "cultureOrigin/784": "origine-de-culture/emirats-arabes-unis",
  "cultureOrigin/792": "origine-de-culture/turquie",
  "cultureOrigin/795": "origine-de-culture/turkmenistan",
  "cultureOrigin/804": "origine-de-culture/ukraine",
  "cultureOrigin/818": "origine-de-culture/egypte",
  "cultureOrigin/826": "origine-de-culture/royaume-uni",
  "cultureOrigin/834": "origine-de-culture/tanzanie",
  "cultureOrigin/840": "origine-de-culture/etats-unis",
  "cultureOrigin/999": "origine-de-culture/export",
  "cultureOrigin/NON_EU": "origine-de-culture/non-ue",
  "cultureOrigin/UE": "origine-de-culture/ue",
  "cultureOrigin/XXX": "origine-de-culture/vide"
};
